import { createRouter, createWebHistory } from 'vue-router'
import { useAuthStore } from '../stores/auth'

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/',
      name: 'home',
      component: () => import('../views/HomeView.vue'),
      beforeEnter: (to, from, next) => {
        const authStore = useAuthStore()
        if (authStore.isAuthenticated) {
          next({ name: 'dashboard' })
        } else {
          next()
        }
      }
    },
    {
      path: '/',
      component: () => import('../layouts/DashboardLayout.vue'),
      meta: { requiresAuth: true },
      mode: 'history',
      children: [
        {
          path: 'dashboard',
          name: 'dashboard',
          component: () => import('../views/dashboard/DashboardView.vue')
        },
        {
          path: 'assets',
          name: 'assets',
          component: () => import('../views/assets/AssetsView.vue')
        },
        {
          path: 'transactions',
          name: 'transactions',
          component: () => import('../views/transactions/TransactionsView.vue')
        },
        {
          path: 'profile',
          name: 'profile',
          component: () => import('../views/profile/ProfileView.vue')
        },
      ]
    },
    {
      path: '/',
      component: () => import('../layouts/AuthLayout.vue'),
      meta: { requiresAuth: false },
      mode: 'history',
      children: [
        {
          path: '/login',
          name: 'login',
          component: () => import('../views/auth/LoginView.vue')
        },
        {
          path: '/register',
          name: 'register',
          component: () => import('../views/auth/RegisterView.vue')
        }
      ]
    },

    // Catch-all route for 404 - redirect to dashboard if authenticated, otherwise to login
    {
      path: '/:pathMatch(.*)*',
      redirect: to => {
        const authStore = useAuthStore()
        return authStore.isAuthenticated ? { name: 'dashboard' } : { name: 'login' }
      }
    }
  ]
})

// Navigation guards
router.beforeEach((to, from, next) => {
  const authStore = useAuthStore()

  // Check token expiration if authenticated
  if (authStore.isAuthenticated) {
    authStore.checkTokenExpiration()

    // If authenticated and trying to access home, login or register, redirect to dashboard
    if (to.name === 'home' || to.name === 'login' || to.name === 'register') {
      return next({ name: 'dashboard' })
    }
  } else {
    // If not authenticated and trying to access protected routes
    if (to.meta.requiresAuth) {
      return next({ name: 'login' })
    }
  }

  next()
})

export default router